import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Phone, Mail, MapPin } from "lucide-react";
import { BRAND, NAV_LINKS } from "../../lib/content";

export const Footer = () => (
  <footer data-testid="footer" className="bg-[#0A0A0A] border-t border-white/10 pt-20 pb-10">
    <div className="max-w-7xl mx-auto px-6 lg:px-8">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <div className="flex items-center gap-2">
            <span className="font-display font-black text-2xl tracking-tight text-white">SPECA</span>
            <span className="w-1 h-1 bg-silver rounded-full" />
            <span className="font-mono-tech text-[10px] tracking-[0.3em] text-gray-500">DETAILING</span>
          </div>
          <p className="text-gray-400 font-light mt-5 max-w-sm leading-relaxed">
            Premium automotive detailing, paint correction and ceramic protection in {BRAND.location}.
            Mobile and in-house services for luxury and performance vehicles.
          </p>
          <p className="overline mt-5 text-silver">{BRAND.training}</p>
          <div className="flex gap-3 mt-6">
            <a href={BRAND.instagram} target="_blank" rel="noopener noreferrer" data-testid="footer-instagram" className="w-11 h-11 flex items-center justify-center border border-white/15 text-gray-300 hover:border-silver hover:text-silver transition-colors">
              <Instagram size={18} />
            </a>
          </div>
        </div>
        <div className="md:col-span-3">
          <p className="overline">Explore</p>
          <ul className="mt-5 space-y-3">
            {NAV_LINKS.map((l) => (
              <li key={l.to}>
                <Link to={l.to} data-testid={`footer-link-${l.to.replace("/", "") || "home"}`} className="text-gray-400 hover:text-white transition-colors text-sm">{l.label}</Link>
              </li>
            ))}
          </ul>
        </div>
        <div className="md:col-span-4">
          <p className="overline">Get In Touch</p>
          <ul className="mt-5 space-y-4">
            <li><a href={`tel:${BRAND.phoneRaw}`} className="flex items-center gap-3 text-gray-400 hover:text-white transition-colors text-sm font-mono-tech"><Phone size={15} className="text-silver" />{BRAND.phone}</a></li>
            <li><a href={`mailto:${BRAND.email}`} className="flex items-center gap-3 text-gray-400 hover:text-white transition-colors text-sm font-mono-tech break-all"><Mail size={15} className="text-silver" />{BRAND.email}</a></li>
            <li className="flex items-center gap-3 text-gray-400 text-sm font-mono-tech"><MapPin size={15} className="text-silver" />{BRAND.location}</li>
          </ul>
          <div className="flex gap-3 mt-6">
            <Link to="/contact" data-testid="footer-quote" className="text-white border border-white/20 hover:border-white px-5 py-2.5 uppercase tracking-widest text-[11px] font-bold transition-colors">Request a Quote</Link>
            <Link to="/contact" data-testid="footer-book" className="bg-silver hover:bg-white text-black px-5 py-2.5 uppercase tracking-widest text-[11px] font-bold transition-colors">Book Now</Link>
          </div>
        </div>
      </div>
      <div className="mt-16 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
        <p className="text-gray-600 text-xs font-mono-tech">© {new Date().getFullYear()} SPECA Detailing · {BRAND.location}</p>
        <p className="text-gray-600 text-xs font-mono-tech">Car Detailing Noble Park · Ceramic Coating Melbourne · Mobile Detailing</p>
      </div>
    </div>
  </footer>
);
